import { RESTClient } from './client';
import { API_URL } from './apiDictionary';

export const fetchDICOMResource = async (clinicalTrialId: string) => {
  try {
    const response = await RESTClient.get<{ url: string }>(
      API_URL.DICOMResource,
      {
        headers: {
          'x-dynamika-clinical-trial-id': clinicalTrialId,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching DICOM Resource', error);
    throw error;
  }
};

export const fetchCommonDICOMResource = async (clinicalTrialId: string) => {
  try {
    const response = await RESTClient.get<{ url: string }>(
      API_URL.commonDICOMResource,
      {
        headers: {
          'x-dynamika-clinical-trial-id': clinicalTrialId,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching Common DICOM Resource', error);
    throw error;
  }
};
